import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    return {x: 0, y: 0}
  },
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home/index.vue'),
      meta: {
        mobile: () => import('@/views/Home/mobile.vue'),
        pc: () => import('@/views/Home/index.vue'), // 👈 明确缓存 PC
      }
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (!to.matched.length) return next()

  const record = to.matched[to.matched.length - 1]

  // 没配置 mobile / pc 的直接放行
  if (!record.meta) return next()

  const isH5 = isMobile()

  // 每次都「显式指定」，不依赖上一次状态
  record.components = record.components || {}
  record.components.default = isH5
    ? record.meta.mobile || record.meta.pc
    : record.meta.pc

  next()
  // 判断是否需要登录权限
  // if (to.matched.some(res => res.meta.requireAuth)) {
  //   // 判断是否登录
  //   if (sessionStorage.getItem('token')) {
  //     next()
  //   } else {
  //     // 没登录则跳转到登录界面
  //     next({
  //       path: '/login',
  //       query: {
  //         redirect: to.fullPath
  //       }
  //     })
  //   }
  // } else {
  //   next()
  // }
})

function isMobile() {
  return window.innerWidth <= 768
}




export default router